import { useState } from "react";
import styles from "./styles.module.css";
import { Grid, MenuItem } from "@mui/material";
import CustomTextField from "../utils/CustomFields/CustomTextField";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ButtonRed from "../utils/CustomFields/ButtonRed";
import ButtonGray from "../utils/CustomFields/ButtonGray";
import { CREDIT_LIMIT_TYPES } from "const";
import toast from "react-hot-toast";

function AddVendor({ closeDialog, addVendorHandler }) {
  const [data, setData] = useState({
    name: "",
    mobile: "",
    code: "",
    address: "",
    balance_type: CREDIT_LIMIT_TYPES.CREDIT,
    balance: 0,
  });

  const handleCreateVendor = () => {
    if (!data.name || !data.mobile) {
      toast.error("Please fill vendor details");
      return;
    }

    if (!data.code) {
      toast.error("Please fill vendor code");
      return;
    }

    const balance = Number(data.balance) || 0;
    const adjustedBalance = data.balance_type === CREDIT_LIMIT_TYPES.CREDIT ? -Math.abs(balance) : Math.abs(balance);

    const payload = {
      ...data,
      balance: adjustedBalance,
    };

    addVendorHandler(payload);
  };

  const handleBalanceChange = (e) => {
    const val = e.target.value;

    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      setData((prev) => ({
        ...prev,
        balance: val,
      }));
    }
  };

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.closeIcoSection}>
          <CloseRoundedIcon onClick={closeDialog} className={styles.icon} />
        </div>

        <div className={styles.headerSection} style={{ paddingBottom: "15px" }}>
          <div>
            <h2>Add Vendor</h2>
            <h4>Register a new vendor and store their information securely.</h4>
          </div>
        </div>

        <Grid container spacing={2} className={styles.contentArea} mb={2}>
          <Grid item xs={12}>
            <CustomTextField
              label="Vendor Name"
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              label="Vendor Mobile"
              value={data.mobile}
              onChange={(e) => setData({ ...data, mobile: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              label="Vendor Code"
              value={data.code}
              onChange={(e) => setData({ ...data, code: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              label="Vendor Address"
              value={data.address}
              onChange={(e) => setData({ ...data, address: e.target.value })}
            />
          </Grid>

          <Grid item xs={5}>
            <CustomTextField
              select
              label="Balance Type"
              value={data.balance_type}
              onChange={(e) => setData({ ...data, balance_type: e.target.value })}
              sx={{
                "& .MuiSelect-select": {
                  color: data.balance_type === CREDIT_LIMIT_TYPES.CREDIT ? "red" : "green",
                },
              }}
            >
              <MenuItem value={CREDIT_LIMIT_TYPES.CREDIT}>Credit (-)</MenuItem>
              <MenuItem value={CREDIT_LIMIT_TYPES.ADVANCE}>Advance (+)</MenuItem>
            </CustomTextField>
          </Grid>

          <Grid item xs={7}>
            <CustomTextField
              label="Opening Balance"
              placeholder="0.00"
              value={data.balance}
              onChange={handleBalanceChange}
            />
          </Grid>
        </Grid>

        <div className={styles.actionButtons}>
          <ButtonGray onClick={closeDialog}>Cancel</ButtonGray>
          <ButtonRed onClick={handleCreateVendor}>Create</ButtonRed>
        </div>
      </div>
    </div>
  );
}

export default AddVendor;
